import { Hidden, Typography } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './styles/AccommodationsTable.styles'

const AccommodationRowSkeleton: React.FC = () => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.tableRowSkeleton}>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <Hidden smDown>
          <div>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
        </Hidden>
        <div />
      </div>
    </>
  )
}

export default AccommodationRowSkeleton
